import ViewResolver from '@Components/ViewResolver/ViewResolver';

import { ManageRequestList } from './desktop';
import { RequestListMobile } from './mobile';
import { ManageRequestListProps } from './desktop/ManageRequestList';
import { RequestListMobileProps } from './mobile/RequestListMobile';

interface PurchaseRequestListProps
  extends ManageRequestListProps,
    RequestListMobileProps {}

const PurchaseRequestList: React.FC<PurchaseRequestListProps> = (
  props
): JSX.Element | null => {
  const {
    onLoadMore,
    onImport,
    onView,
    onExport,
    onDelete,
    onCompare,
    listRequests,
    requestsDataList,
    onChangePage,
    mapColumns,
    dataSource,
    onSort,
    requestType,
    currentPage,
    showAction,
    hidePagination = false,
    isFiltersApplied,
    isSearchApplied,
  } = props;

  if (!listRequests) {
    return null;
  }

  return (
    <ViewResolver
      desktop={
        <ManageRequestList
          showAction={showAction}
          onImport={onImport}
          onView={onView}
          onExport={onExport}
          onDelete={onDelete}
          onCompare={onCompare}
          totalItems={listRequests.totalElements}
          pageSize={listRequests.size}
          onChangePage={onChangePage}
          currentPage={currentPage}
          mapColumns={mapColumns}
          dataSource={dataSource}
          onSort={onSort}
          hidePagination={hidePagination}
          isFiltersApplied={isFiltersApplied}
          isSearchApplied={isSearchApplied}
        />
      }
      mobile={
        <RequestListMobile
          listRequests={listRequests}
          requestsDataList={requestsDataList}
          requestType={requestType}
          showAction={showAction}
          onLoadMore={onLoadMore}
          onImport={onImport}
          onView={onView}
          onExport={onExport}
          onDelete={onDelete}
          isFiltersApplied={isFiltersApplied}
          isSearchApplied={isSearchApplied}
        />
      }
    />
  );
};

export default PurchaseRequestList;
